<template>
    <div
        v-if="props.isHeader"
        class="[&>*:first-child]:justify-self-start [&>*:not(:first-child)]:justify-self-end grid-cols-subgrid col-span-full hidden min-h-12 bg-white px-6 py-3 text-xs text-black content-center @4xl:grid"
        role="row"
    >
        <slot></slot>
    </div>

    <div
        v-else
        class="grid-cols-subgrid gap-y-2 col-span-full grid border-t border-solid border-x-0 border-b-0 border-slate-200 min-h-12 px-6 py-4 even:bg-slate-50 odd:bg-slate-100 items-center content-center @xl:gap-y-0 @4xl:py-3"
        role="row"
    >
        <slot name="rowTitle"></slot>
        <div class="exportable-table-content grid" role="none">
            <slot></slot>
        </div>
        <slot name="buttons"></slot>
    </div>
</template>

<script setup>
const props = defineProps({
    isHeader: {
        type: Boolean,
        default: false,
    },
});
</script>
